import { MaterialDesignContent } from 'notistack';
// @mui
import { styled, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledNotistack = styled(MaterialDesignContent)(({ theme }) => {
  const isLight = theme.palette.mode === 'light';

  return {
    '& .notistack-SnackbarContainer': {
      minWidth: '0px',
    },
    '& #notistack-snackbar': {
      ...theme.typography.input,
      fontWeight: 500,
      padding: 0,
      height: '36px',
    },
    '&.notistack-MuiContent': {
      padding: '8px 24px',
      color: theme.palette.content.primaryWhite1,
      boxShadow: '0.4px 0.8px 4px 0px rgba(0, 0, 0, 0.25)',
      borderRadius: '4px',
      minWidth: '140px',
      width: 'auto',
      backgroundColor: theme.palette.background.primaryBlack1,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '&.notistack-MuiContent-default': {
      color: isLight ? theme.palette.common.white : theme.palette.grey[800],
      backgroundColor: theme.palette.background.primaryBlack1,
    },
    // '&.notistack-MuiContent-info': {},
    // '&.notistack-MuiContent-success': {},
    // '&.notistack-MuiContent-warning': {},
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.background.primaryRed1,
    },
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled('span')(({ color, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '6px',
  color: theme.palette.content.primaryWhite,
}));
